const items = [
  { icon: 'ri-team-line', label: 'Profesyonel Ekip' },
  { icon: 'ri-tools-line', label: 'Profesyonel Ekipman' },
  { icon: 'ri-shopping-bag-3-line', label: 'Malzemeli Hizmet' },
  { icon: 'ri-file-list-3-line', label: 'İşe Özel Planlama' },
  { icon: 'ri-map-pin-2-line', label: 'Geniş Hizmet Bölgesi' },
];

export default function TrustStrip() {
  return (
    <section className="relative z-10 bg-warm-white border-b border-warm-sand">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-10">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 md:gap-8">
          {items.map((item) => (
            <div key={item.label} className="flex flex-col items-center text-center gap-2">
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center text-gold">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <span className="text-navy font-semibold text-sm md:text-base">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}